import type { PackagesT } from './packagesI18n';

export interface PackagesEmptyStateProps {
  t: PackagesT;
  /** Eligible (ACTIVE, not blocked) services; null while unknown (then the CTA shows). */
  eligibleCount: number | null;
  onCreate: () => void;
  onGoToServices: () => void;
}

/** Spec 081b — "No packages yet" + "Create your first package", or why it can't be done yet (< 2 eligible services). */
export default function PackagesEmptyState({ t, eligibleCount, onCreate, onGoToServices }: PackagesEmptyStateProps) {
  const tooFew = eligibleCount != null && eligibleCount < 2;
  return (
    <div className="offer-empty" data-testid="pkg-empty">
      <div className="offer-empty__icon" aria-hidden="true">
        <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
          <path d="M21 8l-9-5-9 5 9 5 9-5z" />
          <path d="M3 8v8l9 5 9-5V8" />
          <path d="M12 13v8" />
        </svg>
      </div>
      <h3>{t('packages.empty.title')}</h3>
      <p>{t('packages.empty.body')}</p>
      {tooFew ? (
        <>
          <p className="pkg-empty__hint" data-testid="pkg-empty-hint">{t('packages.empty.needServices')}</p>
          <button type="button" className="offer-btn offer-btn--ghost" onClick={onGoToServices}>{t('packages.empty.goServices')}</button>
        </>
      ) : (
        <button type="button" className="partner-services-add-btn offer-new-btn" onClick={onCreate}>+ {t('packages.empty.cta')}</button>
      )}
    </div>
  );
}
